import React from 'react'
import _map from 'lodash/map'
import { graphql, compose } from 'react-apollo'

import { Loading } from '@sukiai/components'
import { GetScriptsByUserId } from '@sukiai/gql/app'

import { FETCH_POLICY, getScriptName, LO_STO } from '../../../../lib'
import {
  PageContainer,
  ScriptsContainer,
  Header,
  Body,
  Footer,
  NewScriptButton,
  Script,
  ScriptTitle
} from './amwellScripts.styled'
import loSto from '../../../../config/loSto'

function AmwellScripts ({ loading, scripts, onSelect, createScript }) {
  const renderScript = (script) => (
    <Script
      onClick={() => {
        onSelect(script.id)
      }}
    >
      <ScriptTitle>{getScriptName(script)}</ScriptTitle>
    </Script>
  )

  const renderScripts = () => <>{_map(scripts, renderScript)}</>

  return (
    <PageContainer>
      <ScriptsContainer>
        <Header>Manage Scripts</Header>
        <Body>{loading ? <Loading /> : renderScripts()}</Body>
        <Footer>
          <NewScriptButton onClick={createScript}>+ New script</NewScriptButton>
        </Footer>
      </ScriptsContainer>
    </PageContainer>
  )
}

const mapScriptsToProps = ({ data }) => ({
  errorScripts: data.error,
  loading: data.loading,
  scripts: data?.macros && data?.macros?.results
})

export default compose(
  graphql(GetScriptsByUserId, {
    skip: () =>
      !loSto.get(LO_STO.ORGANIZATION_ID) || !loSto.get(LO_STO.USER_ID),
    options: () => ({
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        userId: loSto.get(LO_STO.USER_ID)
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }),
    props: mapScriptsToProps
  })
)(AmwellScripts)
